'use client'
import React, { useState, useEffect } from 'react'
import { useSearchParams } from "react-router-dom";
import FullScreenSpinner from '../Spinner/FullScreenSpinner'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react'
import { Helmet } from 'react-helmet'
import { ClockIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon, FunnelIcon, MinusIcon, PlusIcon, Squares2X2Icon } from '@heroicons/react/20/solid'
import Products from './Products'
import { Axios } from '../Axios/Axios'

const axios = new Axios();

const filters = [
  {
    id: 'tags',
    key: 'tags',
    name: 'Внатрешна/Надворешна',
    options: [
      { value: 'Внатрешни единици', label: 'Внатрешни единици', checked: false },
      { value: 'Надворешни единици', label: 'Надворешни единици', checked: false },
    ],
  },
  {
    id: 'sub_category',
    key: 'category-1',
    name: 'Разладно Средство',
    options: [
      { value: 'R410A', label: 'R410A', checked: false },
      { value: 'R32', label: 'R32', checked: false },
      { value: 'R134A', label: 'R134A', checked: false },
    ],
  },
  {
    id: 'category',
    key: 'category-2',
    name: 'Категории',
    options: [
      { value: 'Комерцијални системи', label: 'Комерцијални системи', checked: false },
      { value: 'ЕHS топлински пумпи', label: 'ЕHS топлински пумпи', checked: false },
      { value: 'Multisplit системи', label: 'Multisplit системи', checked: false },
      { value: 'Вентилација', label: 'Вентилација', checked: false },
      { value: 'Чилери', label: 'Чилери', checked: false },
      { value: 'Системи за домување', label: 'Системи за домување', checked: false },
      { value: 'VRF системи', label: 'VRF системи', checked: false },
    ],
  },
]

export default function FilterLayout({ pre_fetched_products }) {
  const [searchParams] = useSearchParams();
  const filterParam = searchParams.get("filter");
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
  const [filterProducts, setFilterProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [moreProducts, setMoreProducts] = useState(true);
  const [filterValues, setFilterValues] = useState(() => {
    const newFilters = {};
  
    if (filterParam === 'резиденцијални') {
      newFilters["category"] = ['Multisplit системи', 'ЕHS топлински пумпи'];
    } else if (filterParam === 'комерцијални') {
      newFilters["category"] = ['Чилери', 'VRF системи', 'Комерцијални системи'];
    }
  
    return newFilters;
  });  
  const handlePaginationData = (offset, limit) => {
    // setOffset(offset);
    // setLimit(limit);
  };

  useEffect(() => {

    if (Object.keys(filterValues).length === 0) {
      return;
    }

    setLoading(true);
    axios.post('api/home/filter', {
      limit,
      offset,
      filter_values: filterValues
    })
    .then(res => {
      setFilterProducts(res.data);
      if (res.data.length < limit) {
        setMoreProducts(false);
      }else{
        setMoreProducts(true);
      }
    })
    .catch(err => {
      setMoreProducts(false);
      console.log(err);
    })
    .finally( () => setLoading(false));
  }, [filterValues]);

  const handleFilterChange = async (target) => {
    setMobileFiltersOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  
    const target_value = target.value ?? "";
    const target_column = target.getAttribute("data-column") ?? "";
    const target_checked = target.checked ?? false;
  
    setFilterValues((prevValues) => {
      const newFilters = { ...prevValues };
  
      if (target_checked) {
        if (!newFilters[target_column]) {
          newFilters[target_column] = [];
        }
        newFilters[target_column].push(target_value);
      } else {
        if (newFilters[target_column]) {
          newFilters[target_column] = newFilters[target_column].filter(
            (val) => val !== target_value
          );
          if (newFilters[target_column].length === 0) {
            delete newFilters[target_column];
          }
        }
      }
  
      return newFilters;
    });
  };  

  return (
    <div className="bg-white">
      <Helmet>
        <title>EES | Производи</title>
        <meta name="title" content="Производи | Разгледајте ја Нашата Понуда" />
        <meta name="description" content="Разгледајте ја нашата широка палета на производи кои ги задоволуваат сите ваши потреби." />
        <meta name="keywords" content="производи, понуда, палета, квалитет" />
      </Helmet>
      <div>
        {/* Mobile filter dialog */}
        <Dialog open={mobileFiltersOpen} onClose={setMobileFiltersOpen} className="relative z-40 lg:hidden">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-black/25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />

          <div className="fixed inset-0 z-40 flex">
            <DialogPanel
              transition
              className="relative ml-auto flex size-full max-w-xs transform flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl transition duration-300 ease-in-out data-[closed]:translate-x-full"
            >
              <div className="flex items-center justify-between px-4">
                <h2 className="text-lg font-medium text-gray-900">Филтери</h2>
                <button
                  type="button"
                  onClick={() => setMobileFiltersOpen(false)}
                  className="-mr-2 flex size-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                >
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon aria-hidden="true" className="size-6" />
                </button>
              </div>

              {/* Filters */}
              <form className="mt-4 border-t border-gray-200">
                {filters.map((section) => (
                  <Disclosure key={section.key} as="div" className="border-t border-gray-200 px-4 py-6">
                    <h3 className="-mx-2 -my-3 flow-root">
                      <DisclosureButton className="group flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500">
                        <span className="font-medium text-gray-900">{section.name}</span>
                        <span className="ml-6 flex items-center">
                          <PlusIcon aria-hidden="true" className="size-5 group-data-[open]:hidden" />
                          <MinusIcon aria-hidden="true" className="size-5 group-[&:not([data-open])]:hidden" />
                        </span>
                      </DisclosureButton>
                    </h3>
                    <DisclosurePanel className="pt-6">
                      <div className="space-y-6">
                        {section.options.map((option, optionIdx) => (
                          <div key={option.value} className="flex gap-3">
                            <div className="flex h-5 shrink-0 items-center">
                              <div className="group grid size-4 grid-cols-1">
                              <input
                                  onChange={(e) => handleFilterChange(e.target)}
                                  value={option.value}
                                  data-column={`${section.id}`}
                                  name={`${section.id}[]`}
                                  type="checkbox"
                                  checked={filterValues[section.id]?.includes(option.value) || false}
                                  className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                                />
                                <svg
                                  fill="none"
                                  viewBox="0 0 14 14"
                                  className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                >
                                  <path
                                    d="M3 8L6 11L11 3.5"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="opacity-0 group-has-[:checked]:opacity-100"
                                  />
                                  <path
                                    d="M3 7H11"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                  />
                                </svg>
                              </div>
                            </div>
                            <label
                              htmlFor={`filter-mobile-${section.id}-${optionIdx}`}
                              className="min-w-0 flex-1 text-gray-500"
                            >
                              {option.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </DisclosurePanel>
                  </Disclosure>
                ))}
              </form>
            </DialogPanel>
          </div>
        </Dialog>

        <main className="mx-auto max-w-9xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-baseline justify-between border-b border-gray-200 pb-6 pt-16">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900">Наши производи</h1>
            <div className="flex items-center">
            <button
                type="button"
                onClick={() => setMobileFiltersOpen(true)}
                className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
            >
                <span className="sr-only">Филтери</span>
                <FunnelIcon aria-hidden="true" className="size-5" />
            </button>
            </div>
        </div>

        <section aria-labelledby="products-heading" className="pb-24 pt-6">
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-5">
            {/* Filters */}
            <form className="hidden lg:block">
              {Object.keys(filterValues).length > 0 && (
                <div className="flex justify-between items-center p-4">
                  <p className="text-base text-gray-700">Филтери: {Object.keys(filterValues).length}</p>
                  <button
                    className="underline hover:text-blue-800"
                    onClick={() => setFilterValues({})}
                  >
                    Исчисти сѐ
                  </button>
                </div>

                )
              }
                {filters.map((section) => (
                  <Disclosure key={section.key} as="div" className="border-b border-gray-200 py-6">
                    <h3 className="-my-3 flow-root">
                    <DisclosureButton className="group flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
                        <span className="font-medium text-gray-900">{section.name}</span>
                        <span className="ml-6 flex items-center">
                        <PlusIcon aria-hidden="true" className="size-5 group-data-[open]:hidden" />
                        <MinusIcon aria-hidden="true" className="size-5 group-[&:not([data-open])]:hidden" />
                        </span>
                    </DisclosureButton>
                    </h3>
                    <DisclosurePanel className="pt-6">
                    <div className="space-y-4">
                        {section.options.map((option, optionIdx) => (
                        <div key={option.value} className="flex gap-3">
                            <div className="flex h-5 shrink-0 items-center">
                            <div className="group grid size-4 grid-cols-1">
                            <input
                              onChange={(e) => handleFilterChange(e.target)}
                              value={option.value}
                              data-column={`${section.id}`}
                              name={`${section.id}[]`}
                              type="checkbox"
                              checked={filterValues[section.id]?.includes(option.value) || false}  // Ensures preselection
                              className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                            />
                                <svg
                                fill="none"
                                viewBox="0 0 14 14"
                                className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                >
                                <path
                                    d="M3 8L6 11L11 3.5"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="opacity-0 group-has-[:checked]:opacity-100"
                                />
                                <path
                                    d="M3 7H11"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                />
                                </svg>
                            </div>
                            </div>
                            <label htmlFor={`filter-${section.id}-${optionIdx}`} className="text-sm text-gray-600">
                            {option.label}
                            </label>
                        </div>
                        ))}
                    </div>
                    </DisclosurePanel>
                </Disclosure>
                ))}
            </form>

            {/* Product grid */}
            <div className="lg:col-span-4">
                <Products pre_fetched_products={pre_fetched_products} filter_values={filterValues} filtered_products={filterProducts} moreProducts={moreProducts} onPaginationChange={handlePaginationData} />
            </div>
            </div>
        </section>
        </main>
      </div>
      <FullScreenSpinner display={loading} />
    </div>
  )
}
